import { Output, Component, Input, EventEmitter, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { EButtonType } from "../../../data-types/button.enum";
import { iconsLibrary } from "../../../../theme/constants";
import { StateService } from "../../../services/state.service";
import * as moment from "moment";
@Component({
  selector: "coworker-booking-card",
  templateUrl: "./coworker-booking-card.component.html",
  styleUrls: ["./coworker-booking-card.component.scss"],
})
export class CoworkerBookingCardComponent implements OnInit {
  constructor(private translate: TranslateService) {}
  @Input("bookingStates") bookingStates;
  @Input("booking") booking: any;
  @Input("selected") selected: any;
  @Output("click") click = new EventEmitter();
  @Output("showCancel") showCancel = new EventEmitter();
  public showCancelBookingSection = false;
  public EButtonType = EButtonType;
  ngOnInit() {}

  public newClick() {
    this.click.emit(this.booking);
  }

  get getStatusName() {
    const find = this.bookingStates.find(
      (state) => state.id === this.booking.state_id
    );
    return find.name;
  }

  get showCancelButton() {
    let finishDate = moment(this.booking.start_date, "DD/MM/YYYY");
    finishDate.hours(this.booking.start_time.split(":")[0]);
    finishDate.minutes(this.booking.start_time.split(":")[1]);
    return (
      this.booking.state_id !== 5 &&
      this.booking.state_id !== 6 &&
      moment(finishDate).isAfter(moment())
    );
  }

  public get getSeats() {
    return `${iconsLibrary.seats}`;
  }

  public get getClockActive() {
    return `${iconsLibrary.clockActive}`;
  }
}
